import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/layout/appbar/appbar.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/layout/header-menu-section/header-menu-section.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/layout/header/header.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/layout/sportsbook-layout-container/sportsbook-layout-container.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/layout/sportsbook-main-container/sportsbook-main-container.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/widgets/toast-top/toast-top.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/components/widgets/toast/toast.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/breakpoint/components/breakpoint-display-wrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/league-filter/components/league-filter-modal/league-filter-modal.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/providers/jupiter-sportsbook-provider/jupiter-sportsbook-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/providers/loading-page-provider/loading-page-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/providers/odds-service-provider/odds-service-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/providers/reward-wrapper-provider/reward-wrapper-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/rotate-device/rotate-device.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/sidebar/sidebar.tsx");
